import { render } from "./universal-video.vue?vue&type=template&id=5807b13c&scoped=true"
import script from "./universal-video.vue?vue&type=script&setup=true&lang=ts"
export * from "./universal-video.vue?vue&type=script&setup=true&lang=ts"

import "./universal-video.vue?vue&type=style&index=0&id=5807b13c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5807b13c"
/* hot reload */
if (module.hot) {
  script.__hmrId = "5807b13c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5807b13c', script)) {
    api.reload('5807b13c', script)
  }
  
  module.hot.accept("./universal-video.vue?vue&type=template&id=5807b13c&scoped=true", () => {
    api.rerender('5807b13c', render)
  })

}

script.__file = "resources/ts/components/elements/universal-video.vue"

export default script